import React from "react";
import Card from "./components/Card";

function App() {
  return (
    <div className="wrapper">
      <Card/>
    </div>
  );
}

export default App;
